import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';

import { API_ENDPOINT, useClientApiV1GamesStatsQuery } from '../../resources/@types/accountSchema';
import type { GameType } from '../components/pages/games/common';

export type GamesStatsPeriod = 'daily' | 'monthly' | 'all';
interface UseClientV1GamesStatsQuery {
  gameType: GameType;
  period?: GamesStatsPeriod;
  options?: Parameters<typeof useClientApiV1GamesStatsQuery>[0]['options'];
}

export function useGamesStatsQuery({
  gameType,
  period = 'daily',
  options,
}: UseClientV1GamesStatsQuery) {
  const url = `${API_ENDPOINT.CLIENT_V1_GAMES_STATS}?gameType=${gameType}&period=${period}`;

  return useClientApiV1GamesStatsQuery({
    queryKey: getGamesStatsQueryKey({ gameType, period }),
    url,
    options,
  });
}

export const getGamesStatsQueryKey = ({
  gameType,
  period,
}: { gameType: string; period: string }): QueryKeyReturnType => [
  API_ENDPOINT.CLIENT_V1_GAMES_STATS,
  gameType,
  period,
];
